var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-screen-btn-con",on:{"click":_vm.handleChange}},[_c('Icon',{attrs:{"type":"ios-list-box-outline","size":23}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }